import React from 'react'
import LandingLayout from '../Landing/Index'
import { Loading, FlexContainer } from '../../common'

export const LoadingScreen = () => {
  return (
    <LandingLayout>
      <FlexContainer align='center' justify='center'>
        <Loading loading />
      </FlexContainer>
    </LandingLayout>
  )
}

